document.addEventListener("DOMContentLoaded", function () {
if (!window.location.pathname.includes("/cart")) {
    const cartDrawer = document.getElementById("cart-drawer");
    const closeCartBtn = document.getElementById("close-cart");
    const cartItemsContainer = document.getElementById("cart-items");
    const cartSubtotal = document.getElementById("cart-subtotal");
    const body = document.body;
    const overlay = document.querySelector(".cart-overlay");
    const cartIcon = document.querySelector(".cart-icon");
    const cartIcon2 = document.querySelector(".cart-icon-sticky");

    function openCartDrawer() {
        cartDrawer.classList.add("open");
        body.classList.add("no-scroll");
        updateCart();

    }

    function closeCartDrawer() {
        cartDrawer.classList.remove("open");
        body.classList.remove("no-scroll");
    }



    async function updateCart() {
        try {
            let response = await fetch("/cart.js");
            let cart = await response.json();
            let totalItems = 0;

            if (cart.items && cart.items.length > 0) {
                let cartContent = "";
                cart.items.forEach(item => {
                    totalItems += item.quantity;

                    let itemTotalPrice = (item.final_line_price / 100).toFixed(2); 
                    let variantInfo = '';
                    if (item.variant_title && item.variant_title !== 'Default Title') {
                        variantInfo = `<span class="cart-item-variant">(${item.variant_title})</span>`;
                    }
                    
                    cartContent += `
                        <div class="cart-item" data-key="${item.key}">
                            <img src="${item.image}" alt="${item.product_title}">
                            <div class="cart-item-info">
                                <p>${item.product_title}</p>
                                ${variantInfo}
                                <div class="main-bottom">

                                <div class="cart-item-quantity">
                                    <button class="decrease" data-key="${item.key}">-</button>
                                    <input type="text" class="quantity-input" value="${item.quantity}" data-key="${item.key}" />
                                    <button class="increase" data-key="${item.key}">+</button>
                                </div>
                                <p class="cart-item-price">$${itemTotalPrice}</p>
                                </div>

                            </div>
                            <button class="remove-item" data-key="${item.key}">×</button>
                        </div>`;
                });

                cartItemsContainer.innerHTML = cartContent;
                cartSubtotal.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
                document.getElementById("cart-total-items").textContent = totalItems;
                document.getElementById("header-cart-total-items").textContent = totalItems;  
                document.getElementById("header-cart-total-items-sticky").textContent = totalItems;                  
            } else {
                cartItemsContainer.innerHTML = `
                    <div class="empty-cart">
                        <p>Your cart is empty.</p>
                        <a href="/collections/or-bestsellers" class="shop-now-button">Shop Now</a>
                    </div>`;
                cartSubtotal.textContent = "$0.00";
                document.getElementById("cart-total-items").textContent = "0";
                document.getElementById("header-cart-total-items").textContent = "0";
                document.getElementById("header-cart-total-items-sticky").textContent = "0"; 
            }
          updateCartDrawerVisibility();
            
        } catch (error) {
            console.error("Error fetching cart:", error);
        }

        
    }

    async function updateItemQuantity(key, quantity, button = null) {
        if (quantity < 1) return;

        if (button) toggleLoadingState(button, true);

        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity }),
        });

        if (button) toggleLoadingState(button, false);
        updateCart();
    }

    async function removeCartItem(key, button) {
        toggleLoadingState(button, true);

        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: 0 }),
        });

        toggleLoadingState(button, false);
        updateCart();
    }

    function toggleLoadingState(button, isLoading) {
        if (isLoading) {
            button.dataset.originalContent = button.innerHTML;
            button.innerHTML = `<div class='cart-spinner'></div>`;
            button.disabled = true;
        } else {
            button.innerHTML = button.dataset.originalContent;
            button.disabled = false;
        }
    }

    cartItemsContainer.addEventListener("click", (event) => {
        const button = event.target;
        const key = button.getAttribute("data-key");

        if (button.classList.contains("increase")) {
            let input = button.previousElementSibling;
            let newQuantity = parseInt(input.value) + 1;
            input.value = newQuantity;
            updateItemQuantity(key, newQuantity, button);
        }

        if (button.classList.contains("decrease")) {
            let input = button.nextElementSibling;
            let newQuantity = Math.max(1, parseInt(input.value) - 1);
            input.value = newQuantity;
            updateItemQuantity(key, newQuantity, button);
        }

        if (button.classList.contains("remove-item")) {
            removeCartItem(key, button);
        }
    });

    cartItemsContainer.addEventListener("focusout", (event) => {
        if (event.target.classList.contains("quantity-input")) {
            const key = event.target.getAttribute("data-key");
            const quantity = parseInt(event.target.value) || 1;
            updateItemQuantity(key, quantity);
        }
    });

    document.querySelectorAll(".add-to-cart").forEach(button => {
        button.addEventListener("click", async function (event) {
            event.preventDefault();
            let productId = this.getAttribute("data-id");
            
            toggleLoadingState(this, true);

            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: productId, quantity: 1 }),
            });

            toggleLoadingState(this, false);
            updateCart().then(openCartDrawer);
        });
    });

    closeCartBtn.addEventListener("click", closeCartDrawer);

    document.addEventListener("click", function (event) {
        if (
            !cartDrawer.contains(event.target) &&
            !event.target.closest(".add-to-cart") &&
            !event.target.closest(".cart-overlay") &&
            !event.target.closest(".flatpickr-calendar") 
        ) {
            closeCartDrawer();
        }
    });


    overlay.addEventListener("click", closeCartDrawer);


    cartIcon.addEventListener("click", () => {
        console.log("Cart icon clicked");
        updateCart().then(openCartDrawer);
 
      });
        cartIcon2.addEventListener("click", () => {
        console.log("Cart icon clicked");
        updateCart().then(openCartDrawer);
 
      });


function renderRandomUpsells() {
  const pool = document.querySelectorAll("#upsell-pool .upsell-item");
  const target = document.querySelector("#upsell-target .upsell-items");

  if (!pool.length || !target) return;

  const shuffled = Array.from(pool).sort(() => 0.5 - Math.random()).slice(0, 3);
  target.innerHTML = "";
  shuffled.forEach(item => {
    target.appendChild(item.cloneNode(true));
  });
}

document.addEventListener("submit", async function (e) {
  const form = e.target.closest(".upsell-variant-form");
  if (!form) return;

  e.preventDefault();

  const select = form.querySelector(".upsell-variant-select");
  const hiddenInput = form.querySelector(".upsell-single-variant-id");
  const variantId = select ? select.value : hiddenInput ? hiddenInput.value : null;
  const button = form.querySelector("button");

  if (!variantId) return;

  button.disabled = true;
  button.textContent = "Adding...";

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error("Add to cart failed");

    button.textContent = "Added!";
    
    await updateCart();
    openCartDrawer();
    renderRandomUpsells();

  } catch (err) {
    console.error("Upsell add error:", err);
    button.textContent = "Error";
  } finally {
    setTimeout(() => {
      button.disabled = false;
      button.textContent = "Add to Cart";
    }, 1000);
  }
});

renderRandomUpsells();

document.addEventListener("change", function (e) {
  if (e.target.classList.contains("upsell-variant-select")) {
    const select = e.target;
    const selectedOption = select.options[select.selectedIndex];
    const wrapper = select.closest(".upsell-details");
    const priceEl = wrapper.querySelector(".variant-price");
    const comparePriceEl = wrapper.querySelector(".compare-price");

    const price = selectedOption.dataset.price;
    const compareAt = selectedOption.dataset.compareAtPrice;

    if (priceEl) priceEl.textContent = `$${price}`;
    if (comparePriceEl) {
      if (compareAt) {
        comparePriceEl.style.display = "inline-block";
        comparePriceEl.textContent = `$${compareAt}`;
      } else {
        comparePriceEl.style.display = "none";
      }
    }
  }
});    
    
  function updateCartDrawerVisibility() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const midContainer = document.querySelector('.cart-drawer__mid-container');
        const footer = document.querySelector('.cart-drawer__footer');
        
        if (cart.item_count === 0) {
          if (midContainer) midContainer.style.display = 'none';
          if (footer) footer.style.display = 'none';
        } else {
          if (midContainer) midContainer.style.display = 'block';
          if (footer) footer.style.display = 'block';
        }
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateCartDrawerVisibility();

    document.addEventListener("cart:updated", updateCartDrawerVisibility);
  });


if (document.getElementById('AjaxinateContainer')) {
  var ajaxinate = new Ajaxinate({
    container: '#AjaxinateContainer .collection-products',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    callback: function () {
      console.log('New products loaded.');

      if (window.theme && window.theme.rimg && typeof window.theme.rimg.update === 'function') {
        window.theme.rimg.update();
        console.log('rimg updated via theme script.');
      } else {
        document.querySelectorAll('[data-rimg-template]').forEach(el => {
          const size = el.dataset.rimgMax || '600x600';
          if (el.dataset.rimgTemplate) {
            const imageUrl = el.dataset.rimgTemplate.replace('{size}', size);
            if (el.tagName.toLowerCase() === 'img') {
              el.srcset = imageUrl + ' 1x';
            } else {
              el.style.backgroundImage = `url('${imageUrl}')`;
            }
          }
        });
        console.log('rimg images and backgrounds manually updated.');
      }

      bindAddToCartButtons();
      bindVariantForms();
      forceSelectWrapper(); 
      bindVariantSelectChange();


    }
  });
}

bindAddToCartButtons();
bindVariantForms();
console.log("Variant form handlers initialized"); 
forceSelectWrapper(); 
bindVariantSelectChange();


function bindAddToCartButtons() {
  document.querySelectorAll('.add-to-cart-button').forEach(button => {
    button.removeEventListener('click', handleAddToCart); 
    button.addEventListener('click', handleAddToCart);
  });
}

function handleAddToCart(event) {
  const form = event.currentTarget.closest('.variant-form');


  if (form) return;

  event.preventDefault();
  const productId = event.currentTarget.getAttribute('data-product-id');
  console.log('Add to cart clicked for product ID:', productId);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: productId, quantity: 1 })
  })
  .then(() => updateCart().then(openCartDrawer));
}

function bindVariantForms() {
  document.querySelectorAll('.variant-form').forEach(form => {
    form.removeEventListener('submit', handleVariantFormSubmit);
    form.addEventListener('submit', handleVariantFormSubmit);
  });
}

function handleVariantFormSubmit(event) {
  event.preventDefault();
  const form = event.currentTarget;
  const select = form.querySelector('select');
  const variantId = select.value;
  const button = form.querySelector('button');

  button.disabled = true;
  button.innerHTML = `<div class='cart-spinner'></div>`;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(() => updateCart().then(openCartDrawer))
  .finally(() => {
    button.disabled = false;
    button.innerHTML = 'Add to Cart';
  });
}


function forceSelectWrapper() {
  document.querySelectorAll('.variant-form').forEach(form => {
    const select = form.querySelector('select');
    if (!select) return;

    if (select.closest('.select-wrapper')) return; 

    const wrapper = document.createElement('div');
    wrapper.classList.add('select-wrapper');

    const span = document.createElement('span');
    span.classList.add('selected-text');
    span.textContent = select.options[select.selectedIndex].text.trim();

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(span);
    wrapper.appendChild(select);
  });
}


function bindVariantSelectChange() {
  document.querySelectorAll('.variant-form select').forEach(select => {
    select.addEventListener('change', function () {
      const wrapper = select.closest('.select-wrapper');
      if (wrapper) {
        const span = wrapper.querySelector('.selected-text');
        if (span) {
          span.textContent = select.options[select.selectedIndex].text.trim();
        }
      }
    });
  });
}


async function updateCartAttributes() {
  const smsConsent = document.getElementById("sms-consent")?.checked ? "Yes" : "No";
  const contactNumber = document.getElementById("contact_number")?.value || "";
  const branch = document.getElementById("branch")?.value || "";
  const message = document.getElementById("message")?.value || "";
  const gateCode = document.getElementById("gate_code")?.value || "";
  const occasions = document.getElementById("occasions")?.value || "";
  const date = document.getElementById("date")?.value || "";

  const formData = {
    attributes: {
      "SMS Consent": smsConsent,
      "Contact Number": contactNumber,
      "Branch": branch,
      "Occasions": occasions,
      "message": message,
      "date" : date,
      "GateCode": gateCode,
    },
  };

  try {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    console.log("Cart attributes updated:", formData);
  } catch (err) {
    console.error("Error updating attributes:", err);
  }
}


document.addEventListener("change", (e) => {
  if (
    e.target.matches("#sms-consent, #contact_number, #branch, #occasions, #date, #message, #gate_code")
  ) {
    updateCartAttributes();
  }
});


}


});
